module.exports = __webpack_public_path__ + "static/img/logo-footer.ec8bd039.png";